import { PortalSnapshotSchema, type PortalSnapshot } from "../domain/schema";

export interface PortalRepository {
  load(fallback: PortalSnapshot): PortalSnapshot;
  save(snapshot: PortalSnapshot): void;
}

function migrateLegacySnapshot(input: unknown): unknown {
  if (!input || typeof input !== "object" || Array.isArray(input)) return input;
  const snapshot = input as Record<string, unknown>;
  const entitlements =
    snapshot.entitlements && typeof snapshot.entitlements === "object"
      ? Object.fromEntries(
          Object.entries(snapshot.entitlements as Record<string, unknown>).map(([email, value]) => {
            if (!Array.isArray(value)) return [email, value];
            const migrated = value.flatMap((sku) =>
              sku === "paper-kingdom-agency"
                ? ["paper-kingdom-production", "paper-kingdom-launch-growth"]
                : [sku],
            );
            return [email, [...new Set(migrated)]];
          }),
        )
      : snapshot.entitlements;
  const auditLog = Array.isArray(snapshot.auditLog)
    ? snapshot.auditLog.map((entry) => {
        if (!entry || typeof entry !== "object" || Array.isArray(entry)) return entry;
        const record = entry as Record<string, unknown>;
        return record.offerSku === "paper-kingdom-agency"
          ? { ...record, offerSku: "paper-kingdom-production" }
          : record;
      })
    : snapshot.auditLog;

  return { ...snapshot, entitlements, auditLog };
}

export class BrowserPortalRepository implements PortalRepository {
  constructor(private readonly storageKey: string) {}

  load(fallback: PortalSnapshot): PortalSnapshot {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return fallback;
      const parsed = PortalSnapshotSchema.safeParse(migrateLegacySnapshot(JSON.parse(raw)));
      return parsed.success ? parsed.data : fallback;
    } catch {
      return fallback;
    }
  }

  save(snapshot: PortalSnapshot) {
    localStorage.setItem(this.storageKey, JSON.stringify(snapshot));
  }
}

export const portalRepository: PortalRepository = new BrowserPortalRepository(
  "paper-kingdom.portal.v1",
);
